import React, { FC } from "react";
import { Box, BoxProps } from "@chakra-ui/react";
import { useDispatch } from "react-redux";

import { showModal } from "@shared/store/actions";
import { MODAL_TYPES } from "@shared/constants";
import TrashIcon from "@assets/files/images/icons/trashIcon.svg?react";
import { EvalRunModel } from "@shared/models";
import { actions } from "@containers/Evaluation/store";

interface DeleteEvalRunProps extends BoxProps {
  item: EvalRunModel;
}

const DeleteEvalRun: FC<DeleteEvalRunProps> = ({ onClick, item, ...restProps }) => {
  const dispatch = useDispatch();

  const handleDeleteEvalRun = (e: React.MouseEvent<HTMLDivElement>) => {
    onClick?.(e);
    dispatch(
      showModal({
        type: MODAL_TYPES.CONFIRM,
        props: {
          heading: "Delete evaluation run",
          content: "Are you sure you want to delete this evaluation run? Its results will no longer be listed.",
          cancelBtnText: "Cancel",
          successBtnText: "Delete",
          onSuccess: () => dispatch(actions.deleteEvalRun.request(item.uuid)),
        },
      }),
    );
  };

  return (
    <Box {...restProps} onClick={handleDeleteEvalRun}>
      <TrashIcon />
    </Box>
  );
};

export default DeleteEvalRun;
